export const SITE = {
  name: "BAYTAŞ TARIM",
  tagline: "Tarımın Gücüne Güç Katıyoruz",
  phones: [
    { display: "0506 390 57 63", href: "tel:+905063905763" },
    { display: "0533 643 22 03", href: "tel:+905336432203" },
  ],
  email: "baytastarim@gmail.com",
  address: "Sazlı Mah. Yesevi Cad. No: 4/D, Söke / Aydın",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Sazl%C4%B1+Mahallesi+Yesevi+Caddesi+No+4%2FD+S%C3%B6ke+Ayd%C4%B1n",
  mapsEmbed:
    "https://www.google.com/maps?q=Sazl%C4%B1%20Mahallesi%20Yesevi%20Caddesi%20No%204%2FD%20S%C3%B6ke%20Ayd%C4%B1n&output=embed",
  hours: "Pazartesi – Cumartesi 08:30 – 18:00",
};